// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3eex9","title":"Header_title__1FcWU","side":"Header_side__Y3HZs"};